import {ref} from 'vue';

export type EditorDialogNoticeSaveCallback = (new_val: string) => void;
export interface EditorDialogNoticeShowOptions {
	title: string;
	message: string;
}

export class EditorDialogNoticeStoreControllerClass {
	private static _instance: EditorDialogNoticeStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorDialogNoticeStoreControllerClass());
	}

	private _displayed = ref(false);
	private _message = ref('test message');
	private _title = ref('test title');
	private _on_ok_callback: EditorDialogNoticeSaveCallback | undefined;
	private constructor() {}

	// getters
	displayed(): boolean {
		return this._displayed.value;
	}
	title(): string {
		return this._title.value;
	}
	message(): string {
		return this._message.value;
	}
	execute_on_ok_callback(value: string) {
		if (this._on_ok_callback) {
			const callback = this._on_ok_callback;
			this._on_ok_callback = undefined;
			callback(value);
		}
	}

	// mutations
	async show(options: EditorDialogNoticeShowOptions): Promise<string> {
		return new Promise((resolve, reject) => {
			this._displayed.value = true;
			this._title.value = options.title;
			this._message.value = options.message;
		});
	}
	hide() {
		this._displayed.value = false;
	}
}

export const EditorDialogNoticeStoreController = EditorDialogNoticeStoreControllerClass.instance();
